<script>
	import { cn } from "$lib/utils";
	let className = undefined;
	export { className as class };
</script>

<span class={cn("animate-pulse rounded-md bg-primary/10 inline-block", className)} {...$$restProps}></span>
